import React from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import {
  GetApp as DownloadIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
} from '@mui/icons-material';
import image from '../assets/riyal.png';

const summaryData = {
  totalVAT: '25,000',
  totalSales: '500,000',
  totalPurchases: '200,000',
  netVAT: '15,000',
};

const reports = [
  {
    id: 1,
    period: 'Q1 2024',
    startDate: '2024-01-01',
    endDate: '2024-03-31',
    status: 'Submitted',
    totalVAT: '15,000',
    submissionDate: '2024-04-15',
  },
  {
    id: 2,
    period: 'Q4 2023',
    startDate: '2023-10-01',
    endDate: '2023-12-31',
    status: 'Submitted',
    totalVAT: '12,000',
    submissionDate: '2024-01-15',
  },
  {
    id: 3,
    period: 'Q3 2023',
    startDate: '2023-07-01',
    endDate: '2023-09-30',
    status: 'Submitted',
    totalVAT: '10,000',
    submissionDate: '2023-10-15',
  },
];

function VATReports() {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        VAT Reports
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Total VAT Collected
              </Typography>
              <Typography variant="h5" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <img src={image} alt="currency" style={{ width: '15px', height: '15px' }} />
                {summaryData.totalVAT}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <TrendingUpIcon color="success" />
                <Typography variant="body2" color="success.main" sx={{ ml: 1 }}>
                  +8.5% from last period
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Total Sales
              </Typography>
              <Typography variant="h5" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <img src={image} alt="currency" style={{ width: '15px', height: '15px' }} />
                {summaryData.totalSales}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <TrendingUpIcon color="success" />
                <Typography variant="body2" color="success.main" sx={{ ml: 1 }}>
                  +12% from last period
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Total Purchases
              </Typography>
              <Typography variant="h5" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <img src={image} alt="currency" style={{ width: '15px', height: '15px' }} />
                {summaryData.totalPurchases}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <TrendingDownIcon color="error" />
                <Typography variant="body2" color="error.main" sx={{ ml: 1 }}>
                  -3% from last period
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Net VAT Due
              </Typography>
              <Typography variant="h5" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <img src={image} alt="currency" style={{ width: '15px', height: '15px' }} />
                {summaryData.netVAT}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <TrendingUpIcon color="success" />
                <Typography variant="body2" color="success.main" sx={{ ml: 1 }}>
                  +5% from last period
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6">VAT Return History</Typography>
          <Button
            variant="contained"
            onClick={() => {/* TODO: Implement new report generation */}}
          >
            Generate New Report
          </Button>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Period</TableCell>
                <TableCell>Date Range</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Total VAT</TableCell>
                <TableCell>Submission Date</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reports.map((report) => (
                <TableRow key={report.id}>
                  <TableCell>{report.period}</TableCell>
                  <TableCell>
                    {report.startDate} to {report.endDate}
                  </TableCell>
                  <TableCell>{report.status}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <img src={image} alt="currency" style={{ width: '15px', height: '15px' }} />
                      {report.totalVAT}
                    </Box>
                  </TableCell>
                  <TableCell>{report.submissionDate}</TableCell>
                  <TableCell align="right">
                    <Button
                      startIcon={<DownloadIcon />}
                      onClick={() => {/* TODO: Implement download action */}}
                    >
                      Download
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
}

export default VATReports;